import { memo, useEffect, useMemo, useState } from 'react';
import { uuid } from '@bonanza-social/toolkit/utils';
import { AnimatedCoinsConfig } from './AnimatedCoins.types';
import AnimatedCoin from './AnimatedCoin/AnimatedCoin';
import Box from '../Box/Box';

export const Coins: { animate: (config: AnimatedCoinsConfig) => void } = {
  animate: () => {},
};

function AnimatedCoins() {
  const [config, setConfig] = useState<AnimatedCoinsConfig>();
  const coins = useMemo(
    () => config && Array.from({ length: config.count }, () => uuid()),
    [config],
  );

  useEffect(() => {
    Coins.animate = setConfig;
  }, []);

  return (
    <Box pointerEvents="none" absoluteFill>
      {config &&
        coins?.map((id, index) => (
          <AnimatedCoin key={id} index={index} {...config} />
        ))}
    </Box>
  );
}

export default memo(AnimatedCoins);
